import { render, staticRenderFns } from "./practiceAnalysisCard.vue?vue&type=template&id=128d0d8e&scoped=true&"
import script from "./practiceAnalysisCard.vue?vue&type=script&lang=js&"
export * from "./practiceAnalysisCard.vue?vue&type=script&lang=js&"
import style0 from "./practiceAnalysisCard.vue?vue&type=style&index=0&id=128d0d8e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "128d0d8e",
  null
  
)

export default component.exports